export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
export const DOWNLOAD_VCARD = 'DOWNLOAD_VCARD';
export const DOWNLOAD_VCARD_FAILED = 'DOWNLOAD_VCARD_FAILDE';
export const DOWNLOAD_VCARD_SUCCESS = 'DOWNLOAD_VCARD_SUCCESS';